import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TPpwrPackagingType } from 'redux/reducers/ppwr/types';

export const DEFAULT_PACKAGING_TYPE_SELECTOR = 'defaultPckgTypeId';

export const tableStructure: TTableStructure<keyof TPpwrPackagingType>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'pckgTypeName',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Handler',
		selector: 'pckgTypeHandler',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Examples',
		selector: 'examples',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Jotform Product Pack Handler',
		selector: 'jotformProductPackHandler',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Proof Required',
		selector: 'proofRequired',
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Default Packaging Type',
		selector: DEFAULT_PACKAGING_TYPE_SELECTOR,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Created By',
		selector: 'createdBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [{ name: 'Edit', icon: EIconButtons.EDIT }],
	},
];
